import React from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAngleDoubleRight,
    faCheck,
    faEdit,
    faFileInvoice,
    faInfo,
    faQuestionCircle,
    faRemove,
    faSearch,
    faSpinner,
    faTimes,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
// import unitsOfMeasure from "../../../services/unitsOfMeasure.json";
import { useAppContext } from "../../../AppContext";
import { useTranslation } from "react-i18next";
import func from "../../../services/functions";
import cities from "../../../services/cities.json";
import mainAxios from "../../../services/mainAxios";
import { toast } from "react-toastify";
import Loader from "../../Layout/Loader";
import { useState } from "react";
import AlertCertificate from "../../global/AlertCertificate";
import PopOver from "../../global/PopOver";
import diacritics from 'diacritics';
import Swal from "sweetalert2";
import TransportInvTable from "./TransportInvTable";
import { compactSelect } from "../../../design/selectStyle";
import MobileInvoiceWizard from "../DemoWizardSteps/MobileInvoiceWizard";





const getExpandButtons = () =>
    document.querySelectorAll(
        "[aria-label='Expand Row'], [aria-label='Collapse Row']"
    );

let itemCount = 0;

const normalizeCityValue = (value) => {
    if (!value) return "";
    return String(value).trim();
};

const getCityOption = (value) => {
    const normalizedValue = normalizeCityValue(value);
    if (!normalizedValue) return undefined;
    return cities?.find((city) => {
        const optionValue = normalizeCityValue(city?.value);
        const optionLabel = normalizeCityValue(city?.label);
        return (
            diacritics?.remove(optionValue).toLowerCase() === diacritics?.remove(normalizedValue).toLowerCase() ||
            diacritics?.remove(optionLabel).toLowerCase() === diacritics?.remove(normalizedValue).toLowerCase()
        );
    });
};

const getCanonicalCityValue = (value) => {
    const matchedCity = getCityOption(value);
    if (matchedCity?.value) return matchedCity.value;

    const normalizedValue = normalizeCityValue(value).toLowerCase();
    if (normalizedValue.startsWith("tiran")) {
        return getCityOption("Tiranë")?.value ?? "Tiranë";
    }

    return normalizeCityValue(value);
};


const TransportContent = ({ transportState, setTransportState, canEdit, pageState, handleSave, errors, buttons, unitsOfMeasure,isEdit, ...props }) => {
    const issueDateRef = React.useRef();
    const { t, i18n } = useTranslation("translations");


    const popOver = {
        NOINTERNET: t("hints.noInternet"),
        BOUNDBOOK: t("hints.boundBook"),
        SERVICE: t("hints.service"),
        TECHNICALERROR: t("hints.TechnicalError"),
    };

    const {
        user: [user],
        loadingVersion: loadingVersion,
        showVersion: showVersion,
        handleShowVersion,
        selectedCompany: [selectedCompany],
        company: [fullCompany]
    } = useAppContext();
    const company = user.companiesRights.find(
        (company) => company.id === parseInt(selectedCompany)
    );
    const [showBanner, setShowBanner] = useState(true);
    const [inputClass, setInputClass] = React.useState("");
    const [recieverInputClass, setRecieverInputClass] = React.useState("");
    const [minIssueDate, setMinIssueDate] = React.useState("");


    React.useEffect(() => {
        if (transportState?.items.length > itemCount && getExpandButtons().length > 0) {
            const buttons = getExpandButtons();
            buttons[buttons.length - 1].click();
        }
        itemCount = transportState?.items?.length;
    }, [transportState?.items?.length]);

    const CustomOption = ({ innerProps, isDisabled, label, data }) =>
        !isDisabled ? (
            <div className="option-custom-style" {...innerProps}>
                {/* {label} <PopOver title={popoOver.find(popover=>popover.value==data.value).popoOver} /> */}
                {label} <PopOver title={popOver[data.value]} />
                {innerProps.label}
            </div>
        ) : null;

        const handleSubseqChange = (subseq) => {
            const { value, label } = subseq;
            setTransportState((transportState) => ({
              ...transportState,
              subseq: value,
            }));
            var newDate = new Date();

            if (value === "BOUNDBOOK") {
              newDate = func.dateBeforeSomeDays(11, newDate);
            } else if (value === "SERVICE" || value === "TECHNICALERROR") {
              newDate = func.dateBeforeSomeDays(1, newDate);
            } else {
              newDate = func.getMinIssueDate();
            }
            const { issueDate } = transportState;

            setMinIssueDate(newDate);

            if (
              (value === "BOUNDBOOK" ||
                value === "SERVICE" ||
                value === "TECHNICALERROR") &&
              issueDate < newDate
            ) {
              setTransportState((transportState) => ({
                ...transportState,
                issueDate: new Date(),
              }));
              issueDateRef.current.setOpen(true);
            }
          };

    const handleKeyDown = (e) => {
        if (e.key === " ") {
            e.preventDefault();
        }
    };
    const handleInputChange = (value, key) => {
        const keys = key.split(".");
        switch (keys.length) {
            case 1:
                setTransportState((transportState) => ({
                    ...transportState,
                    [keys[0]]: value,
                }));
                break;
            case 2:
                setTransportState((transportState) => ({
                    ...transportState,
                    [keys[0]]: {
                        ...transportState[keys[0]],
                        [keys[1]]: value,
                    },
                }));
                break;
            case 3:
                setTransportState((transportState) => ({
                    ...transportState,
                    [keys[0]]: {
                        ...transportState[keys[0]],
                        [keys[1]]: {
                            ...transportState[keys[0]][keys[1]],
                            [keys[2]]: value,
                        },
                    },
                }));
                break;
            default:
                return;
        }
    };

    const handleIssueDateChange = (date) => {
        setTransportState((transportState) => ({
          ...transportState,
          issueDate: date,
        }));
        issueDateRef.current.setOpen(false);

        let today = new Date();
        let technicalErrorMinDate = func.dateBeforeSomeDays(1, today);
        let boundBookMinDate = func.dateBeforeSomeDays(10, today);

        if (date == "" || date == null) return;
        today = today.setHours(0, 0, 0, 0);
        // date = date.setHours(0, 0, 0, 0);
        technicalErrorMinDate = technicalErrorMinDate.setHours(0, 0, 0, 0);
        boundBookMinDate = boundBookMinDate.setHours(0, 0, 0, 0);
        if (date >= today) {
          setTransportState((transportState) => ({
            ...transportState,
            subseq: "",
          }));
          return;
        }
        if (date >= technicalErrorMinDate && date < today) {
          setTransportState((transportState) => ({
            ...transportState,
            subseq: "SERVICE",
          }));
        } else if (date >= boundBookMinDate && boundBookMinDate < today) {
          setTransportState((transportState) => ({
            ...transportState,
            subseq: "BOUNDBOOK",
          }));
        } else {
          setTransportState((transportState) => ({
            ...transportState,
            subseq: "NOINTERNET",
          }));
        }
      };

    const handleTaxPayerChange = (e) => {
        let value = e.target.value;

        setTransportState((transportState) => ({
            ...transportState,
            parties: {
                ...transportState?.parties,
                transporter: {
                    ...transportState?.parties?.transporter,
                    idNum: value?value.trim():"",
                },
            },
        }));

        if (inputClass.length > 0) setInputClass("");
    };

    const handleTaxPayerSearch = ({setClass=setInputClass,nipt,onSuccess}) => {
        let transporterNIPT = transportState?.parties?.transporter?.idNum
            ?.split(" ")
            .join("").trim();

        let value= nipt ?? transporterNIPT;

        if (canEdit) {
            if (new RegExp("[a-zA-Z]{1}[0-9]{8}[a-zA-Z]{1}").test(value)) {
                    setClass("loading");
                    mainAxios
                        .post("apiEndpoint/search", {
                            object: "GetTaxpayersRequest",
                            value: value,
                        })
                        .then((res) => {
                            if (res?.data?.status === true) {
                                if (res.data.content.length === 0) {
                                    toast.warning(t(["toast.noTaxPayer"]), {
                                        containerId: "all_toast",
                                    });
                                    setInputClass("error");
                                } else {
                                    const taxPayer = res.data.content[0];
                                    if(onSuccess){
                                        onSuccess(taxPayer);
                                    }else{
                                        setTransportState((transportState) => ({
                                            ...transportState,
                                            parties: {
                                                ...transportState?.parties,
                                                transporter: {
                                                    ...transportState?.parties?.transporter,
                                                    name: taxPayer?.name ? taxPayer?.name?.slice(0, 99) : null,
                                                    town: getCanonicalCityValue(taxPayer?.town?.slice(0, 99)),
                                                    address: taxPayer?.address
                                                        ? taxPayer?.address.slice(0, 200)
                                                        : null,
                                                },
                                            },
                                        }));
                                    }
                                    setClass("success");
                                }
                            } else {
                                setClass("error");
                            }
                        })
                        .catch((e) => {
                            setClass("error");
                        });
            } else {
                toast.error(t(["toast.incorrectNipt"]), { containerId: "all_toast" });
                setClass("error");
            }
        }
    };

    const handleRecieverTaxSearch=()=>{
        let nipt = transportState?.parties?.buyer?.tin
        ?.split(" ")
        .join("").trim();

        handleTaxPayerSearch({nipt,setClass:setRecieverInputClass,onSuccess:(taxPayer)=>{
            setTransportState((transportState) => ({
                ...transportState,
                parties: {
                    ...transportState?.parties,
                    buyer: {
                        ...transportState?.parties?.buyer,
                        name: taxPayer?.name ? taxPayer?.name?.slice(0, 99) : null,
                        town: getCanonicalCityValue(taxPayer?.town?.slice(0, 99)),
                        address: taxPayer?.address
                            ? taxPayer?.address.slice(0, 200)
                            : null,
                    },
                },
            }));
        }});
    }


    const handleAddressChange = (index, value, key,fixedHours) => {
        let updatedValue = value;

        if (fixedHours && value) {
            updatedValue = new Date(value.getTime());

            const currentTime = new Date();
            updatedValue.setHours(currentTime.getHours(), currentTime.getMinutes(), 0, 0);
        }
        setTransportState((transportState) => ({
            ...transportState,
            address: [
                ...transportState.address.slice(0, index),
                {
                    ...transportState.address[index],
                    [key]: updatedValue,
                },
                ...transportState.address.slice(index + 1),
            ],
        }));
    };

    const handleBranchChange = async (branch) => {
        if (branch && !branch.existCis) {
            const result = await Swal.fire({
                title: t(['notification.businessUnitNotActiveInCIS']),
                icon: 'warning',
                width: '800px',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
                cancelButtonText: t(['common.cancel'])
            });

            if (!result.isConfirmed) {
                return;
            }
        }

        const orderedTcrs =
        (branch?.tcrTypes?.filter((tcrType) => {
            return tcrType?.allowInvoice;
        }) ?? [])
        .sort((a, b) => b.recordDate - a.recordDate);

        const tcrCode=orderedTcrs?.[0]?.tcrCode ?? ""

        setTransportState((transportState) => ({
            ...transportState,
            businessUnitCode: branch?.businUnitCode,
            tcrCode
        }));
    };


    const deleteItem = (itemId) => {
        const index = transportState.items.findIndex((item) => item.id === itemId);
        setTransportState((transportState) => ({
            ...transportState,
            items: [
                ...transportState.items.slice(0, index),
                ...transportState.items.slice(index + 1),
            ],
        }));
    };

    const typeOptions = [
        {
            label: t("navbar.transportInvoice"),
            value: "TI",
        },
    ];

    const transactionOptions = [
        { label: t("transportInv.processing"), value: "PROCESSING" },
        { label: t("transportInv.repair"), value: "REPAIR" },
        { label: t("invoice.examinationWtn"), value: "EXAMINATION" },

    ];

    const fullBranchMap = React.useMemo(() => {
        const map = {};
        if (fullCompany?.branches) {
            for (const fb of fullCompany.branches) {
                map[fb.businUnitCode] = fb;
            }
        }
        return map;
    }, [fullCompany?.branches]);

    // This line is needed if we want to remove branches that don't have TCR
    // const branchesOptions = company && company.branches.filter(branch => branch.tcrTypes.filter(tcrType => !!tcrType.tcrCode).length > 0).map((data) => ({
    const branchesOptions = React.useMemo(() => {
        return company &&
        company.branches.map((data) => {
            const existCis = fullBranchMap[data.businUnitCode]?.existCis ?? true;
            return {
                ...data,
                label: data.businUnitCode + " - " + data.sellerAddress,
                value: data.businUnitCode,
                existCis,
                inactive: !existCis
            };
        });
    }, [company?.branches, fullBranchMap]);

    // const tcrOptions =
    //     company &&
    //     [
    //         ...new Set(
    //             company.branches
    //                 .reduce((acc, next) => acc.concat(next.tcrTypes), [])
    //                 .map((tcr) => ({...tcr,inactive:!tcr.existCis && tcr.status < 100}))
    //                 .filter((tcrType) => !!tcrType.tcrCode)
    //                 .map((tcr) => tcr.tcrCode)
    //         ),
    //     ].map((tcrCode) => ({
    //         label: tcrCode,
    //         value: tcrCode,
    //     }));


    const tcrList = React.useMemo(() => {
        let filteredBranch = company.branches.find(
          (branch) => branch.businUnitCode == transportState.businessUnitCode
        );
        let tcrTypes =
          filteredBranch?.tcrTypes.filter((tcrType) => tcrType?.allowInvoice)
          .sort((a, b) => new Date(b.recordDate) - new Date(a.recordDate)) ?? [];
        let tcrList =
          tcrTypes.map((tcr) => {
            let sellerName = filteredBranch.sellerName;
            return {
              label: tcr.tcrCode + "-" + sellerName,
              value: tcr.tcrCode,
              inactive: tcr.status < 100
            };
          }) ?? [];

        return tcrList.length > 0
          ? [{ label: "Select", value: "" }].concat(tcrList)
          : tcrList;
      }, [selectedCompany, transportState?.businessUnitCode]);


        console.log({tcrList,company})

    const packTypes = [
        { value: "Boxes", label: "Boxes" },
        { value: "Pallets", label: "Pallets" },
        { value: "Containers", label: "Containers" },
        { value: "Parcels", label: "Parcels" },
        { value: "Dunnage", label: "Dunnage" },
        { value: "Other", label: "Other" },
    ];

    const ownershipOptions = [
        { value: "OWNER", label: t("transportInv.owner") },
        { value: "THIRDPARTY", label: t("transportInv.thirdparty") },
    ];

    const idTypes = [
        { value: "NUIS", label: t("invoice.Nuis") },
        { value: "ID", label: t("transportInv.personalId") },
    ];

    const destinationPoints = [
        { value: "WAREHOUSE", label: t("transportInv.warehouse") },
        { value: "EXHIBITION", label: t("transportInv.exhibition") },
        { value: "STORE", label: t("transportInv.store") },
        { value: "OTHER", label: t("transportInv.other") },
    ];

    const addressPoints = [
        { value: "WAREHOUSE", label: t("transportInv.warehouse") },
        { value: "EXHIBITION", label: t("transportInv.exhibition") },
        { value: "STORE", label: t("transportInv.store") },
        // { value: "SALE", label: t("transportInv.sale") },
        // { value: "ANOTHER", label: t("transportInv.another") },
        // { value: "CUSTOMS", label:t("transportInv.customs") },
        { value: "OTHER", label: t("transportInv.other") },
    ];

    const subseqValues = [
        { value: "", label: "Select" },
        { value: "NOINTERNET", label: "No Internet" },
        { value: "BOUNDBOOK", label: "Boundbook" },
        { value: "SERVICE", label: "Service" },
        { value: "TECHNICALERROR", label: "Technical Error" },
    ];

    const generalSection = (
        <>
            <h3 className="card-title d-flex align-items-start border-bottom pb-1">
                {t("invoice.general")}
            </h3>
            <div className="row">
                <div className="col-md-6">
                    <label htmlFor="type">{t("customers.type")}</label>
                    <span className="text-danger"> *</span>
                    <Select
                        name="type"
                        id="type"
                        styles={compactSelect}
                        options={typeOptions}
                        required
                        value={typeOptions.find(
                            (typeOption) => typeOption?.value === transportState?.type
                        )}
                        onChange={(type) => handleInputChange(type.value, "type")}
                        isDisabled={!canEdit}
                    />
                    <label htmlFor="transaction">{t('invoice.transaction')}</label>
                    <span className="text-danger"> *</span>
                    <Select
                        name="transaction"
                        id="transaction"
                        styles={compactSelect}
                        options={transactionOptions}
                        value={transactionOptions.find(
                            (transactionOption) =>
                                transactionOption?.value === transportState?.transaction
                        )}
                        onChange={(transaction) =>
                            handleInputChange(transaction?.value, "transaction")
                        }
                        isDisabled={!canEdit}
                    />
                    <label htmlFor="issueDate">{t('table.issueDatetime')}</label>
                    <span className="text-danger"> *</span>
                    <DatePicker
                        ref={issueDateRef}
                        selected={transportState?.issueDate}
                        dateFormat="dd/MM/yyyy HH:mm"
                        name="issueDate"
                        id="issueDate"
                        autoComplete="off"
                        showTimeSelect
                        calendarClassName="transport-datepicker transport-datepicker--time-left"
                        minDate={minIssueDate ? minIssueDate : func.getMinIssueDate()}
                        showDisabledMonthNavigation
                        onChange={(date) => {handleInputChange(date, "issueDate");handleIssueDateChange(date)}}
                        customInput={<input className="form-control form-control-sm" />}
                        disabled={!canEdit}
                    />
                    <label htmlFor="businUnitCode">{t("invoice.branch")}</label>
                    <span className="text-danger"> *</span>
                    <Select
                        name="businUnitCode"
                        id="businUnitCode"
                        styles={compactSelect}
                        isSearchable={true}
                        options={branchesOptions}
                        // options={tcrOptions.filter(tcrOption => {
                        //     const selectedBranch = branchesOptions.find(branchesOption => branchesOption.businUnitCode === transportState.businUnitCode)
                        //     return selectedBranch?.tcrTypes.find(tcrType => tcrType.tcrCode === tcrOption.value)
                        // })}
                        value={branchesOptions.find(
                            (branchesOption) =>
                                branchesOption?.businUnitCode === transportState?.businessUnitCode
                        )}
                        onChange={(branchesOption) =>
                            handleBranchChange(branchesOption)
                        }
                        isDisabled={!canEdit}
                    />
                    <label htmlFor="tcrCode">{t("company.tcrTypes")}</label>
                    <Select
                        name="tcrCode"
                        id="tcrCode"
                        styles={compactSelect}
                        isSearchable={true}
                        options={tcrList}
                        value={
                            tcrList.find(
                                (tcrOption) => tcrOption?.value === transportState?.tcrCode
                            ) || ""
                        }
                        onChange={(tcrOption) =>
                            handleInputChange(tcrOption.value, "tcrCode")
                        }
                        isDisabled={!canEdit}
                    />
                    <label htmlFor="vehiclePlate">
                        {t("invoice.plate")}
                        <span className="text-danger"> *</span>
                    </label>
                    <input
                        type="text"
                        onKeyDown={handleKeyDown}
                        name="vehiclePlate"
                        id="vehiclePlate"
                        className={`form-control form-control-sm ${errors['vehicle.vehiclePlate'] ? "is-invalid" : ""} `}
                        value={transportState?.vehicle?.vehiclePlate}
                        onChange={(e) =>
                            handleInputChange(e.target.value, "vehicle.vehiclePlate")
                        }
                        disabled={!canEdit}
                    />
                    <label className="field-label">
                        Subseq
                        <PopOver title={t("invoice.subseq")} />
                    </label>
                    <Select
                        components={{ Option: CustomOption }}
                        options={subseqValues}
                        value={subseqValues.find(
                            (subseqWtn) => transportState?.subseq === subseqWtn?.value
                        )}
                        isDisabled={!canEdit}
                        styles={compactSelect}
                        onChange={(subseqWtn) => handleSubseqChange(subseqWtn)}
                        name="subseq"
                    />
                </div>
                <div className="col-md-6 ">
                    <label htmlFor="packType">{t("invoice.packType")}</label>
                    <span className="text-danger"> *</span>
                    <Select
                        name="packType"
                        id="packType"
                        styles={compactSelect}
                        isSearchable={true}
                        options={packTypes}
                        value={packTypes.find(
                            (packType) => packType?.value === transportState?.packType
                        )}
                        onChange={(packType) =>
                            handleInputChange(packType.value, "packType")
                        }
                        isDisabled={!canEdit}
                    />
               <label htmlFor="packNum">
                        {t("invoice.packNum")}
                        <span className="text-danger"> *</span>
                    </label>
                    <input
                        type="number"
                        name="packNum"
                        id="packNum"
                        min={0}
                        className={`form-control form-control-sm ${errors.packNum ? "is-invalid" : ""
                            } `}
                        value={transportState?.packNum}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            if (newValue < 0) {
                                document.getElementById("error-packNum").textContent = t("invoice.negativeValue");
                                return;
                            }
                            document.getElementById("error-packNum").textContent = "";
                            handleInputChange(newValue, "packNum");
                        }}
                        disabled={!canEdit}

                    />
                    <div id="error-packNum" className="text-danger t"></div>

                <label htmlFor="valueOfGoods">
                        {t("invoice.valueOfGoods")}
                        <span className="text-danger"> *</span>
                    </label>
                    <input
                        type={canEdit ? "number" : "text"}
                        name="valueOfGoods"
                        id="valueOfGoods"
                        min={0}
                        className={`form-control form-control-sm text-right ${errors.valueOfGoods ? "is-invalid" : ""
                            } `}
                        value={canEdit ? transportState.valueOfGoods : func.formatNumber(transportState?.valueOfGoods)}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            if (newValue < 0) {
                                document.getElementById("error-valueOfGoods").textContent = t("invoice.negativeValue");
                                return;
                            }
                            document.getElementById("error-valueOfGoods").textContent = "";
                            handleInputChange(newValue, "valueOfGoods");
                        }}
                        disabled={!canEdit}
                    />
                    <div id="error-valueOfGoods" className="text-danger"></div>

                    <label htmlFor="internalId"> {fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "internalId")?.value ?? t("home.internalId")}</label>
                    <input
                        type="text"
                        name="internalId"
                        id="internalId"
                        className='form-control form-control-sm'
                        value={transportState?.internalId}
                        onChange={(e) =>
                            handleInputChange(e.target.value, "internalId")
                        }
                        disabled={!canEdit}
                    />
                    <label htmlFor="vehicleOwnership">{t("invoice.ownership")}</label>
                    <span className="text-danger"> *</span>
                    <Select
                        name="vehicleOwnership"
                        id="vehicleOwnership"
                        styles={compactSelect}
                        isSearchable={true}
                        options={ownershipOptions}
                        value={ownershipOptions.find(
                            (ownershipOption) =>
                                ownershipOption?.value ===
                                transportState?.vehicle?.vehicleOwnership
                        )}
                        onChange={(ownershipOption) =>
                            handleInputChange(
                                ownershipOption.value,
                                "vehicle.vehicleOwnership"
                            )
                        }
                        isDisabled={!canEdit}
                        required
                    />
                    <div className="mt-4">
                        <div className="custom-control custom-switch mr-3">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                name="goodsFammable"
                                id="goodsFammable"
                                checked={transportState.goodsFammable}
                                onChange={(e) =>
                                    handleInputChange(e.target.checked, "goodsFammable")
                                }
                                disabled={!canEdit}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="goodsFammable"
                            >
                                {t("invoice.areFlammable")}
                            </label>
                        </div>
                        <div className="custom-control custom-switch mr-3">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                name="escortRequired"
                                id="escortRequired"
                                checked={transportState.escortRequired}
                                onChange={(e) =>
                                    handleInputChange(e.target.checked, "escortRequired")
                                }
                                disabled={!canEdit}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="escortRequired"
                            >
                                {t("invoice.escortRequired")}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    const issuerSection = (
        <>
            <h3 className="card-title d-flex align-items-start border-bottom pb-1">
                {t("invoice.issuer")}
            </h3>
            <div className="col-md-12 px-0">
                <label htmlFor="sellerIdType">{t("invoice.idType")}</label>
                <span className="text-danger"> *</span>
                <input
                    type="text"
                    name="sellerIdType"
                    id="sellerIdType"
                    className="form-control form-control-sm"
                    value={transportState.parties.seller.sellerIDType}
                    disabled
                />
                <label htmlFor="tin">{t("invoice.Nuis")}</label>
                <span className="text-danger"> *</span>
                <input
                    type="text"
                    name="tin"
                    id="tin"
                    className="form-control form-control-sm"
                    value={transportState.parties.seller.tin}
                    disabled
                />
                <label htmlFor="sellerName">{t("customers.name")}</label>
                <span className="text-danger"> *</span>
                <input
                    type="text"
                    name="sellerName"
                    id="sellerName"
                    className="form-control form-control-sm"
                    value={transportState.parties.seller.name}
                    disabled
                />
                <label htmlFor="sellerTown">{t("customers.town")}</label>
                <span className="text-danger"> *</span>
                <input
                    type="text"
                    name="sellerTown"
                    id="sellerTown"
                    className="form-control form-control-sm"
                    value={transportState.parties.seller.town}
                    disabled
                />
                <label htmlFor="sellerAddress">{t("customers.address")}</label>
                <span className="text-danger"> *</span>
                <textarea
                    rows="3"
                    name="sellerAddress"
                    id="sellerAddress"
                    className="form-control form-control-sm"
                    value={transportState.parties.seller.address}
                    disabled
                />
            </div>
        </>
    );

    const transporterSection = (
        <>
            <h3 className="card-title d-flex align-items-start border-bottom pb-1">
                {t("invoice.transporter")}
            </h3>
            <div className="col-md-12 px-0">
                <label htmlFor="idType">{t("invoice.idType")}</label>
                <span className="text-danger"> *</span>
                <Select
                    name="idType"
                    id="idType"
                    styles={compactSelect}
                    isSearchable={true}
                    options={idTypes}
                    value={idTypes.find(
                        (idType) =>
                            idType.value === transportState.parties.transporter.idType
                    )}
                    onChange={(idType) =>
                        handleInputChange(
                            idType.value,
                            "parties.transporter.idType"
                        )
                    }
                    isDisabled={!canEdit}
                />
                {transportState?.parties?.transporter?.idType === "NUIS" ? (
                    <>
                        <label className="form-label">
                            {transportState.parties.transporter.idType}
                            <span className="text-danger"> *</span>
                        </label>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleTaxPayerSearch(e);
                            }}

                        >
                            <div className="input-group position-relative">
                                <input
                                    name="buyer"
                                    type="text"
                                    className={
                                        "form-control form-control-sm required" +
                                        (inputClass === "error" || errors['parties.transporter.idNum']
                                            ? " border-danger"
                                            : inputClass === "success"
                                                ? " border-success"
                                                : "")
                                    }

                                    value={transportState?.parties?.transporter?.idNum}
                                    disabled={!canEdit}
                                    onChange={handleTaxPayerChange}
                                />
                                <div className="input-group-append">
                                    <span
                                        className="input-group-text cursor-pointer"
                                        onClick={handleTaxPayerSearch}
                                    >
                                        <FontAwesomeIcon icon={faSearch} />
                                    </span>
                                </div>
                                {inputClass === "loading" && (
                                    <div className="input-icon input-loader">
                                        <Loader size="xs" />
                                    </div>
                                )}
                                {inputClass === "error" && (
                                    <div className="input-icon text-danger">
                                        <FontAwesomeIcon icon={faTimes} />
                                    </div>
                                )}
                                {inputClass === "success" && (
                                    <div className="input-icon text-success">
                                        <FontAwesomeIcon icon={faCheck} />
                                    </div>
                                )}
                            </div>
                                {errors['parties.transporter.idNum']&&<div className="text-danger text-sm">{transportState?.parties?.transporter?.idType==="NUIS"? t("toast.incorrectNipt"):t("toast.incorrectId")}</div>}
                        </form>
                    </>
                ) : (
                    <div>
                        <label htmlFor="idNum">
                            {transportState.parties.transporter.idType}
                            <span className="text-danger"> *</span>
                        </label>
                        <input
                            type="text"
                            name="idNum"
                            id="idNum"
                            className={`form-control form-control-sm ${errors['parties.transporter.idNum'] ? "is-invalid" : ""} `}
                            value={transportState?.parties?.transporter?.idNum}
                            onChange={(e) =>{
                                let val=e.target.value
                                handleInputChange(
                                    val?val.trim():"",
                                    "parties.transporter.idNum"
                                )
                            }
                            }
                            disabled={!canEdit}
                        />
                        {errors['parties.transporter.idNum']&&<div className="text-danger text-sm">{transportState?.parties?.transporter?.idType==="NUIS"? t("toast.incorrectNipt"):t("toast.incorrectId")}</div>}

                    </div>
                )}
                <label htmlFor="transporterName">
                    {t("customers.name")}
                    <span className="text-danger"> *</span>
                </label>
                <input
                    type="text"
                    name="transporterName"
                    id="transporterName"
                    className={`form-control form-control-sm ${errors['parties.transporter.name'] ? "is-invalid" : ""
                        } `}
                    value={transportState.parties.transporter.name}
                    onChange={(e) =>
                        handleInputChange(
                            e.target.value,
                            "parties.transporter.name"
                        )
                    }
                    disabled={!canEdit}
                />
                <label htmlFor="transporterTown"> {t("customers.town")}</label>
                <span className="text-danger"> *</span>
                <Select
                    name="transporterTown"
                    id="transporterTown"
                    styles={compactSelect}
                    isSearchable={true}
                    options={cities}
                    value={getCityOption(transportState?.parties?.transporter?.town)}
                    onChange={(city) =>
                        handleInputChange(city?.value, "parties.transporter.town")
                    }
                    isDisabled={!canEdit}
                />

                <label htmlFor="transporterAddress">
                    {t("customers.address")}
                    <span className="text-danger"> *</span>
                </label>
                <textarea
                    rows="3"
                    name="transporterAddress"
                    id="transporterAddress"
                    className={`form-control form-control-sm ${errors['parties.transporter.address'] ? "is-invalid" : ""
                        } `}
                    value={transportState.parties.transporter.address}
                    onChange={(e) =>
                        handleInputChange(
                            e.target.value,
                            "parties.transporter.address"
                        )
                    }
                    disabled={!canEdit}
                />
            </div>
        </>
    );

    const receiverSection = (
        <>
            <h3 className="card-title d-flex align-items-start border-bottom pb-1">
                {t("transportInv.receiver")}
            </h3>
            <div className="col-md-12 px-0">
                <label htmlFor="buyerIDType">{t("invoice.idType")}</label>
                <span className="text-danger"> *</span>
                <Select
                    name="buyerIDType"
                    id="buyerIDType"
                    styles={compactSelect}
                    isSearchable={true}
                    isDisabled={true}
                    options={idTypes}
                    value={idTypes.find(
                        (idType) =>
                            idType.value === transportState.parties.buyer.buyerIDType
                    )}
                    onChange={(idType) =>{
                        handleInputChange(
                            idType.value,
                            "parties.buyer.buyerIDType"
                        )
                    }

                    }
                    // isDisabled={!canEdit}
                />
                {transportState?.parties?.buyer?.buyerIDType === "NUIS" ? (
                    <>
                        <label className="form-label">
                            {/* {transportState.parties.buyer.buyerIDType} */}
                           { t("invoice.Nuis")}
                            <span className="text-danger"> *</span>
                        </label>
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleRecieverTaxSearch(e);
                            }}

                        >
                            <div className="input-group position-relative">
                                <input
                                    name="buyer"
                                    type="text"
                                    className={
                                        "form-control form-control-sm required" +
                                        (recieverInputClass === "error" || errors['parties.buyer.tin']
                                            ? " border-danger"
                                            : recieverInputClass === "success"
                                                ? " border-success"
                                                : "")
                                    }

                                    value={transportState?.parties?.buyer?.tin}
                                    disabled={!canEdit}
                                    onChange={(e)=>{
                                        handleInputChange(e.target.value,"parties.buyer.tin")
                                        if (recieverInputClass.length > 0) setRecieverInputClass("");
                                    }}
                                />
                                <div className="input-group-append">
                                    <span
                                        className="input-group-text cursor-pointer"
                                        onClick={handleRecieverTaxSearch}
                                    >
                                        <FontAwesomeIcon icon={faSearch} />
                                    </span>
                                </div>
                                {recieverInputClass === "loading" && (
                                    <div className="input-icon input-loader">
                                        <Loader size="xs" />
                                    </div>
                                )}
                                {recieverInputClass === "error" && (
                                    <div className="input-icon text-danger">
                                        <FontAwesomeIcon icon={faTimes} />
                                    </div>
                                )}
                                {recieverInputClass === "success" && (
                                    <div className="input-icon text-success">
                                        <FontAwesomeIcon icon={faCheck} />
                                    </div>
                                )}
                            </div>
                                {errors['parties.buyer.buyerIDType']&&<div className="text-danger text-sm">{transportState?.parties?.buyer?.buyerIDType==="NUIS"? t("toast.incorrectNipt"):t("toast.incorrectId")}</div>}
                        </form>
                    </>
                ) : (
                    <div>
                        <label htmlFor="tin">
                            {transportState.parties.buyer.buyerIDType}
                            <span className="text-danger"> *</span>
                        </label>
                        <input
                            type="text"
                            name="tin"
                            id="tin"
                            className={`form-control form-control-sm ${errors['parties.buyer.tin'] ? "is-invalid" : ""} `}
                            value={transportState?.parties?.buyer?.tin}
                            onChange={(e) =>{
                                let val=e.target.value
                                handleInputChange(
                                    val?val.trim():"",
                                    "parties.buyer.tin"
                                )
                            }
                            }
                            disabled={!canEdit}
                        />
                        {errors['parties.buyer.tin']&&<div className="text-danger text-sm">{transportState?.parties?.buyer?.buyerIDType==="NUIS"? t("toast.incorrectNipt"):t("toast.incorrectId")}</div>}

                    </div>
                )}
                <label htmlFor="buyerName">
                    {t("customers.name")}
                    <span className="text-danger"> *</span>
                </label>
                <input
                    type="text"
                    name="buyerName"
                    id="buyerName"
                    className={`form-control form-control-sm ${errors['parties.buyer.name'] ? "is-invalid" : ""
                        } `}
                    value={transportState.parties.buyer.name}
                    onChange={(e) =>
                        handleInputChange(
                            e.target.value,
                            "parties.buyer.name"
                        )
                    }
                    disabled={!canEdit}
                />
                <label htmlFor="buyerTown"> {t("customers.town")}</label>
                <span className="text-danger"> *</span>
                <Select
                    name="buyerTown"
                    id="buyerTown"
                    styles={compactSelect}
                    isSearchable={true}
                    options={cities}
                    value={getCityOption(transportState?.parties?.buyer?.town)}
                    onChange={(city) =>
                        handleInputChange(city?.value, "parties.buyer.town")
                    }
                    isDisabled={!canEdit}
                />

                <label htmlFor="buyerAddress">
                    {t("customers.address")}
                    <span className="text-danger"> *</span>
                </label>
                <textarea
                    rows="3"
                    name="buyerAddress"
                    id="buyerAddress"
                    className={`form-control form-control-sm ${errors['parties.buyer.address'] ? "is-invalid" : ""
                        } `}
                    value={transportState.parties.buyer.address}
                    onChange={(e) =>
                        handleInputChange(
                            e.target.value,
                            "parties.buyer.address"
                        )
                    }
                    disabled={!canEdit}
                />
            </div>
        </>
    );

    const addressSection = (
        <>
            <h3 className="card-title d-flex align-items-start border-bottom pb-1">
                {t("invoice.startAdr")}
            </h3>
            <div className="col-md-12 mb-4 px-0">
                <label htmlFor="startPoint">{t("invoice.startPoint")}</label>
                <span className="text-danger"> *</span>
                <Select
                    name="startPoint"
                    id="startPoint"
                    styles={compactSelect}
                    isSearchable={true}
                    options={addressPoints}
                    value={addressPoints?.find(
                        (addressPoint) =>
                            addressPoint?.value === transportState?.address[0]?.point
                    )}
                    onChange={(addressPoint) =>
                        handleAddressChange(0, addressPoint.value, "point")
                    }
                    isDisabled={!canEdit}
                />
                <label htmlFor="startDate">
                    {t("invoice.startDate")}
                    <span className="text-danger"> *</span>
                </label>
                <DatePicker
                    selected={transportState.address[0].date}
                    dateFormat="dd/MM/yyyy HH:mm"
                    name="startDate"
                    id="startDate"
                    autoComplete="off"
                    showTimeSelect
                    calendarClassName="transport-datepicker transport-datepicker--time-left"
                    timeIntervals={5}
                    timeCaption={t("common.time", "Time")}
                    // minDate={new Date()}
                    showDisabledMonthNavigation
                    onChange={(date) =>
                        handleAddressChange(0, date, "date")
                    }
                    onSelect={(date) => handleAddressChange(0, date, "date",true)}
                    customInput={<input
                        className={`form-control form-control-sm ${errors['address.0.date'] ? 'is-invalid' : ''} `}
                    />}
                    disabled={!canEdit}
                />
                <label htmlFor="startCity">{t("taxpayer.city")}</label>
                <span className="text-danger"> *</span>
                <Select
                    name="startCity"
                    id="startCity"
                    styles={compactSelect}
                    isSearchable={true}
                    options={cities}
                    value={cities.find(
                        (city) => city.value === transportState.address[0].city
                    )}
                    onChange={(city) =>
                        handleAddressChange(0, city.value, "city")
                    }
                    isDisabled={!canEdit}
                />
                <label htmlFor="startAddress">
                    {t("customers.address")}
                    <span className="text-danger">*</span>
                </label>
                <textarea
                    rows="2"
                    name="startAddress"
                    id="startAddress"
                    className={`form-control form-control-sm ${errors['address.0.address'] ? "is-invalid" : ""
                        } `}
                    value={transportState.address[0].address}
                    onChange={(e) =>
                        handleAddressChange(0, e.target.value, "address")
                    }
                    disabled={!canEdit}
                />
            </div>
            <h3 className="card-title d-flex align-items-start border-bottom pb-1">
                {t("invoice.destinationAddr")}
            </h3>
            <div className="col-md-12 px-0">
                <label htmlFor="destinationPoint">
                    {t("invoice.destPoint")}
                </label>
                <span className="text-danger"> *</span>
                <Select
                    name="destinationPoint"
                    id="destinationPoint"
                    styles={compactSelect}
                    isSearchable={true}
                    options={destinationPoints}
                    value={destinationPoints.find(
                        (addressPoint) =>
                            addressPoint.value === transportState.address[1].point
                    )}
                    onChange={(addressPoint) =>
                        handleAddressChange(1, addressPoint.value, "point")
                    }
                    isDisabled={!canEdit}
                />
                <label htmlFor="destinationDate">
                {t("invoice.arrivalDate")}
                    <span className="text-danger"> *</span>
                </label>
                <DatePicker
                style={{position:"relative"}}
                    selected={transportState.address[1].date}
                    // dateFormat="dd/MM/yyyy"
                    name="destinationDate"
                    id="destinationDate"
                    autoComplete="off"
                    dateFormat="dd/MM/yyyy HH:mm"
                    showTimeSelect
                    calendarClassName="transport-datepicker transport-datepicker--time-left"
                    timeIntervals={5}
                    timeCaption={t("common.time", "Time")}
                    showDisabledMonthNavigation
                    onChange={(date) => handleAddressChange(1, date, "date")}
                    onSelect={(date) => handleAddressChange(1, date, "date",true)}
                    customInput={<input
                    style={{position:"relative"}}
                        className={`form-control form-control-sm ${errors['address.1.date'] ? 'is-invalid' : ''} `}
                    />}
                    disabled={!canEdit}
                />
                <label htmlFor="destionationCity">{t("taxpayer.city")}</label>
                <span className="text-danger"> *</span>
                <Select
                    name="destionationCity"
                    id="destionationCity"
                    styles={compactSelect}
                    isSearchable={true}
                    options={cities}
                    value={cities.find(
                        (city) => city.value === transportState.address[1].city
                    )}
                    onChange={(city) =>
                        handleAddressChange(1, city.value, "city")
                    }
                    isDisabled={!canEdit}
                />
                <label htmlFor="destinationAddress">
                    {t("customers.address")}
                    <span className="text-danger"> *</span>
                </label>
                <textarea
                    rows="2"
                    name="destinationAddress"
                    id="destinationAddress"
                    className={`form-control form-control-sm ${errors['address.1.address'] ? "is-invalid" : ""
                        } `}
                    value={transportState.address[1].address}
                    onChange={(e) =>
                        handleAddressChange(1, e.target.value, "address")
                    }
                    disabled={!canEdit}
                />
            </div>
        </>
    );

    return (
        <>
            <div className="demoInvoice">
                <div>
                    <div className="row">
                        <div className={`col-12 col-md-10 mx-auto`}>
                            <div className="card p-xl-2">
                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center invoice-toolbar">
                                    <div className="d-flex align-items-center flex-wrap invoice-toolbar-checks">
                                        {transportState?.status?.status && (
                                            <span>
                                                {transportState?.status?.status === 'READY_FOR_APPROVAL' && <small className="badge badge-info">{transportState?.status?.status}</small>}
                                                {transportState?.status?.status === "APPROVED" && <small className="badge badge-success">{transportState?.status?.status}</small>}
                                                {transportState?.status?.status === "DRAFT" && <small className="badge badge-secondary">{transportState?.status?.status}</small>}
                                                {transportState?.status?.status === "DELETED" && <small className="badge badge-danger">{transportState?.status?.status}</small>}
                                                {transportState?.status?.status === "ERROR" &&
                                                <small className="badge badge-danger d-inline-flex align-items-center" data-tooltip-id="global-tooltip" data-tooltip-content={transportState?.errorMessage}>{transportState?.status?.status}
                                                    {transportState?.errorMessage && <FontAwesomeIcon icon={faQuestionCircle} className="ml-2" />}
                                                </small>}
                                            </span>
                                        )}
                                    </div>
                                    <div className="d-flex flex-wrap align-items-center gap-2 mt-2 mt-md-0 invoice-toolbar-actions">
                                        <div className="d-flex align-items-center mr-3">
                                            <AlertCertificate />
                                        </div>
                                        <div className="actions d-flex flex-wrap gap-2">
                                            {
                                                transportState?.status?.status === 'DRAFT'
                                                    || transportState?.status?.status === 'READY_FOR_APPROVAL'
                                                    || transportState?.status?.status === 'APPROVED'
                                                    || transportState?.status?.status === 'ERROR'
                                                    || transportState?.status?.status === 'DELETED'
                                                    ?
                                                    buttons
                                                    :
                                                    <button
                                                        className="btn btn-sm btn-success"
                                                        disabled={pageState?.saving}
                                                        style={{ minWidth: "80px" }}
                                                        onClick={handleSave}
                                                    >
                                                        {pageState?.saving ? (
                                                            <Loader size="xs" color="white" />
                                                        ) : (
                                                            t(["common.save"])
                                                        )}
                                                    </button>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="my-2 border-top border-success"></div>

                                {/* Desktop layout */}
                                <div className="row d-none d-md-flex">
                                    <div className="col-12 col-md-4 border-right h-100">
                                        {generalSection}
                                    </div>
                                    <div className="col-12 col-md-8 h-100">
                                        <div className="row">
                                            <div className="col-12 col-md-4 h-100 py-0 mb-1">
                                                {issuerSection}
                                            </div>
                                            <div className="col-12 col-md-4 border-left h-100 py-0">
                                                {transporterSection}
                                            </div>
                                            <div className="col-12 col-md-4 border-left h-100 py-0">
                                                {receiverSection}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Mobile wizard */}
                                <div className="d-md-none">
                                    <MobileInvoiceWizard errors={errors} steps={[
                                        {
                                            label: t("invoice.general"),
                                            errorKeys: ["vehicle.vehiclePlate", "packNum", "valueOfGoods"],
                                            content: generalSection,
                                        },
                                        {
                                            label: t("invoice.issuer"),
                                            errorKeys: [/^parties\.seller\./],
                                            content: issuerSection,
                                        },
                                        {
                                            label: t("invoice.transporter"),
                                            errorKeys: [/^parties\.transporter\./],
                                            content: transporterSection,
                                        },
                                        {
                                            label: t("transportInv.receiver"),
                                            errorKeys: [/^parties\.buyer\./],
                                            content: receiverSection,
                                        },
                                        {
                                            label: t("invoice.startAdr"),
                                            errorKeys: [/^address\./],
                                            content: addressSection,
                                        },
                                    ]} />
                                </div>

                                <TransportInvTable
                                    transportState={transportState}
                                    canEdit={canEdit}
                                    errors={errors}
                                    unitsOfMeasure={unitsOfMeasure}
                                    deleteItem={deleteItem}
                                    setTransportState={setTransportState}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-2 d-none d-md-block">
                            <div className="pt-md-1 pt-xl-2">
                                {addressSection}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default TransportContent
